const GTM_SCRIPT_ID = 'gtm-script';
const getDataLayer = () => {
    var _a;
    window.dataLayer = (_a = window.dataLayer) !== null && _a !== void 0 ? _a : [];
    return window.dataLayer;
};
/**
 * Loads Google Tag Manager as an external script. Does the same as Google's inline snippet,
 * but without inline code, so it keeps working under a CSP without 'unsafe-inline'.
 * Only the first call adds the script; later calls are no-ops, so events are not duplicated.
 */
export const initializeGtm = (gtmId) => {
    if (document.getElementById(GTM_SCRIPT_ID)) {
        return;
    }
    getDataLayer().push({ 'gtm.start': Date.now(), event: 'gtm.js' });
    const script = document.createElement('script');
    script.id = GTM_SCRIPT_ID;
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtm.js?id=${encodeURIComponent(gtmId)}`;
    document.head.appendChild(script);
};
/**
 * Pushes an event to the GTM data layer. Events pushed before GTM is initialized (e.g. before
 * cookie consent) wait in the data layer and are processed once GTM loads.
 */
export const pushToDataLayer = (event) => {
    getDataLayer().push(event);
};
